import moment from "moment";

export default {
    methods: {
        focusOnInput(target) {
            if (typeof target === "undefined") {
                target = 'input';
            }

            setTimeout(() => {
                const el = document.querySelector(target);

                if (!el) return;

                el.focus();
            }, 0);
        },
        formatDate(date, lang) {
            moment.locale(!!lang ? lang : this.$root.languages.current);
            return moment(date).format("ll")
        },
        loadActionPlans() {
            return this.$http.get(`${window.api_endpoint}/action-plan/plans`).then(response => response.body.data);
        },
        loadPlan(planId) {
            return this.$http.get(`${window.api_endpoint}/action-plan/plan/${planId}`).then(response => response.body);
        },
        saveActionPlan(data) {
            return this.$http.post(`${window.api_endpoint}/action-plan/plan`, data).then(response => response.body)
        },
        updateActionPlan(planId, data) {
            return this.$http.put(`${window.api_endpoint}/action-plan/plan/${planId}`, data).then(response => response.body)
        },
        deleteActionPlan(planId) {
            return this.$http.delete(`${window.api_endpoint}/action-plan/plan/${planId}`).then(response => response.body)
        },
        saveGoal(data) {
            return this.$http.post(`${window.api_endpoint}/action-plan/goal`, data).then(response => response.body);
        },
        updateGoal(goalId, data) {
            return this.$http.put(`${window.api_endpoint}/action-plan/goal/${goalId}`, data).then(response => response.body)
        },
        deleteGoal(goalId) {
            return this.$http.delete(`${window.api_endpoint}/action-plan/goal/${goalId}`).then(response => response.body)
        },
        saveTask(data) {
            return this.$http.post(`${window.api_endpoint}/action-plan/task`, data).then(response => response.body);
        },
        updateTask(taskId, data) {
            return this.$http.put(`${window.api_endpoint}/action-plan/task/${taskId}`, data).then(response => response.body)
        },
        deleteTask(taskId) {
            return this.$http.delete(`${window.api_endpoint}/action-plan/task/${taskId}`).then(response => response.body)
        }
    }
}